import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from 'components/Heading';
import PageSection from 'components/PageSection';
import UserSkillsWidget from 'screens/UserSkills';
function UserSkillsTab() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(PageSection, null, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    mb: "l"
  }, t('your_skills_title')), /*#__PURE__*/React.createElement(UserSkillsWidget, null));
}
export default UserSkillsTab;